import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  TableCell,
  TableRow,
  Table,
  TableBody,
  TableHead,
  Paper,
  TableContainer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Autocomplete,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  externaldeleteApi,
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import {
  RECIPE_API_01,
  RECIPE_API_02,
  RECIPE_API_03,
  RECIPE_API_04,
} from "../../api/ApiModel";
import GradingIcon from "@mui/icons-material/Grading";
import { Tooltip, IconButton } from "@mui/material";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import SearchAppBar from "../../components/common/search";
function AddRecipe() {
  const [errors, setErrors] = useState({});
  const [datashop, setDatashop] = useState([]);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [rows1, setRows1] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERREFCODE, USERNAME, LOCCODE } =
    SYS_USER.USER_PARAM || {};
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const location = useLocation();
  const { MENUCODE, MENUCATCODE, MENUNAME, actionText, Image } = location.state || {};

  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedMenuCode, setSelectedMenuCode] = useState(null);



  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const gotToPage = () => {
    navigate("/ViewLocations");
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };


  //-------------------functions----------------
  useEffect(() => {
    console.log("Selected MENUCODE:", selectedMenuCode);
  }, [selectedMenuCode]);
  const [ingredients, setIngredientsData] = useState([]); // ✅ Fix here
  const [exchangeRates, setExchangeRates] = useState({});
  const [savedRates, setSavedRates] = useState([]);
  const [description, setDescription] = useState("");
  // Load saved rates from session storage on mount
 useEffect(() => {
  const storedRates = JSON.parse(sessionStorage.getItem("exchangeRates")) || [];

  // ✅ Ensure it's always an array
  if (Array.isArray(storedRates)) {
    setSavedRates(storedRates);
  } else {
    setSavedRates([]); // reset if it's not an array
  }
}, []);


  // Save rates to session storage
  const saveToSessionStorage = (rates) => {
    sessionStorage.setItem("exchangeRates", JSON.stringify(rates));
  };

  const handleInputChange = (productCode, value) => {
    setExchangeRates((prev) => ({
      ...prev,
      [productCode]: value, // Use PRODUCTCODE as key for qty
    }));
  };

  const handleAddRate = (row) => {
    // Check for duplication
const alreadyExists =
  savedRates.some((item) => String(item.PRODUCTCODE) === String(row.PRODUCTCODE)) ||
  ingredients.some((item) => String(item.PRODUCTCODE) === String(row.PRODUCTCODE));

if (alreadyExists) {
  setSnackbarMessage("This product is already added.");
  setSnackbarSeverity("error");
  setSnackbarOpen(true);
  return;
}
    const qty = exchangeRates[row.PRODUCTCODE];
    if (!qty || isNaN(qty) || Number(qty) <= 0) {
      setSnackbarMessage("Please enter a valid quantity.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    const newSavedRates = [
  ...savedRates,
  {
    ...row,
    PRODUCTNAME: row.PRODUCTNAME,
    PRODUCTCODE: row.PRODUCTCODE,
    QTY: qty,
    MENUCODE: selectedMenuCode?.MENUCODE || MENUCODE || "", // <-- Add MENUCODE here
  },
];
    setSavedRates(newSavedRates);
    saveToSessionStorage(newSavedRates);
    setExchangeRates((prev) => ({ ...prev, [row.PRODUCTCODE]: "" })); // Reset qty input
  };

  const handleDeleteRate = (index) => {
    const updatedRates = savedRates.filter((_, idx) => idx !== index);
    setSavedRates(updatedRates);
    saveToSessionStorage(updatedRates);
  };

  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const [saveDialogMessage, setSaveDialogMessage] = useState("");

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];
const handleConfirm = async () => {
  // Load from sessionStorage in case state got cleared
  const storedRates =
    JSON.parse(sessionStorage.getItem("exchangeRates")) || [];
  const finalRates = savedRates.length > 0 ? savedRates : storedRates;

  // ✅ Validate menu selection
  if (!selectedMenuCode?.MENUCATCODE && !MENUCATCODE) {
    setSnackbarMessage("Select the menu before saving.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }

  // ✅ Only block if BOTH are empty
  if ((!finalRates || finalRates.length === 0) && (!ingredients || ingredients.length === 0)) {
    setSnackbarMessage("Select the product to map.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }

  const menuCodeValue = selectedMenuCode?.MENUCODE || MENUCODE || "";
  const menuCatCodeValue = selectedMenuCode?.MENUCATCODE || MENUCATCODE || "";

  // ✅ Merge finalRates + ingredients into dtRecipe
  const dtRecipe = [
    ...(finalRates && finalRates.length > 0
      ? finalRates.map((row) => ({
          PRODUCTCODE: String(row.PRODUCTCODE),
          PRODUCTNAME: row.PRODUCTNAME,
          QTY: row.QTY,
          CATCODE: String(row.CATCODE) || "",
          SUBCATCODE: String(row.SUBCATCODE) || "",
        }))
      : []),
    ...(ingredients && ingredients.length > 0
      ? ingredients.map((row) => ({
          PRODUCTCODE: String(row.PRODUCTCODE),
          PRODUCTNAME: row.PRODUCTNAME,
          QTY: row.QTY,
          CATCODE: String(row.CATCODE) || "",
          SUBCATCODE: String(row.SUBCATCODE) || "",
        }))
      : []),
  ];

  const payload = {
    dtRecipe,
    COMPCODE,
    LOCCODE,
    RESTCODE,
    MENUCODE: String(menuCodeValue),
    MENUCATCODE: String(menuCatCodeValue),
    description,
    STS: CON_STATUS_ACTIVE,
    enuser: USERNAME,
  };

  try {
    console.log("Payload for API call:", payload);
    const response = await externalpostApi(RECIPE_API_02, payload);

    setSnackbarMessage("Product Updated Successfully!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);

    sessionStorage.removeItem("exchangeRates");
    setSavedRates([]);
    setTimeout(() => {
      navigate("/RecipeItems");
    }, 1000);
  } catch (error) {
    console.error("Error during API call:", error);
  }
};


  const [updatedProducts, setUpdatedProducts] = useState([]);
  const [showUpdateForm, setShowUpdateForm] = useState(true);

const handleUpdate = async () => {
  const storedRates =
    JSON.parse(sessionStorage.getItem("exchangeRates")) || [];

  const finalRates = savedRates.length > 0 ? savedRates : storedRates;

  // ✅ Validate menu selection
  if (!selectedMenuCode?.MENUCATCODE && !MENUCATCODE) {
    setSnackbarMessage("Select the menu before saving.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }

  // ✅ Only show error if BOTH finalRates and ingredientsData are empty
  if ((!finalRates || finalRates.length === 0) && (!ingredients || ingredients.length === 0)) {
    setSnackbarMessage("Select the product to map.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }

  setShowUpdateForm(false);
  setOpenSaveDialog(true);

  // ✅ Build payload only from finalRates
const payload = [
  // include finalRates only if not empty
  ...(finalRates && finalRates.length > 0
    ? finalRates.map((row) => ({
        productcode: Number(row.PRODUCTCODE),
        productname: row.PRODUCTNAME,
        itemcostwithtax: 0, // new items → always 0
        itemcostwithouttax: 0,
      }))
    : []),

  // always include ingredients
  ...(ingredients && ingredients.length > 0
    ? ingredients.map((row) => ({
        productcode: Number(row.PRODUCTCODE),
        productname: row.PRODUCTNAME,
        itemcostwithtax: row.itemcostwithtax || 0,
        itemcostwithouttax: row.itemcostwithouttax || 0,
      }))
    : []),
];


  console.log("Payload:", payload);

  try {
    const response = await externalpostApi(RECIPE_API_03, payload);
    console.log("API Response:", response);

     setUpdatedProducts( response);
    setSaveDialogMessage(""); // Clear old message
    setOpenSaveDialog(true); // Open the dialog
  } catch (error) {
   
    setUpdatedProducts([]);
    setOpenSaveDialog(true);
  }
};


  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
    }
  }, [dataloc]);

  useEffect(() => {
  const savedRates = sessionStorage.getItem("saverates");
  if (savedRates) {
    setUpdatedProducts(JSON.parse(savedRates));
  }
}, [showUpdateForm]);


useEffect(() => {
  if (ingredients.length > 0) {
    setDescription(ingredients[0].DESCRIPTION || ingredients[0].description || "");
  }
}, [ingredients]);



  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(RECIPE_API_01, "get", {
          COMPCODE: COMPCODE,
          LOCCODE: LOCCODE,
          RESTCODE: RESTCODE,
          STS: CON_STATUS_ACTIVE,
        });

         if (result?.Table1) {
        setData2(result.Table1);
          // If MENUCODE exists, auto-select the matching menu and show its IMAGEPATH
        if (MENUCODE) {
          const foundMenu = result.Table1.find(
            (item) => String(item.MENUCODE) === String(MENUCODE)
          );
          if (foundMenu) {
            setSelectedMenuCode(foundMenu);
          }
        }

     
        console.log("Table2 data:", result.Table1);
      } else {
       
      }
       
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

  const [openGradingDialog, setOpenGradingDialog] = useState(false);



  useEffect(() => {
    fetchDatarecipe();
  }, [MENUCODE, MENUCATCODE]);

  const fetchDatarecipe = async () => {
    try {
      const result = await externalgetApi(RECIPE_API_02, "get", {
        MENUCATCODE: MENUCATCODE,
        MENUCODE: MENUCODE,
        STS: CON_STATUS_ACTIVE,
      });
      setIngredientsData(result || []);
      
      console.log("Fetched ingredients.......:", result);
    } catch (err) {
      setIngredientsData([]); // Clear ingredients on error
    }
  };

  const gotToView = () => {
    navigate("/RecipeItems");
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    if (datashop) {
      const filtered = datashop.filter((item) => {
        const menuname = item.PRODUCTNAME || "";
        return menuname.toLowerCase().includes(searchText.toLowerCase());
      });

      setDatashop(filtered);
    }
  }, [searchText, datashop]);

const handleDelete = async (MENUCODE, MENUCATCODE) => {
  try {
    await externaldeleteApi(RECIPE_API_02, "DELETE", {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      MENUCODE: MENUCODE,
      MENUCATCODE: MENUCATCODE,
      ENUSER: USERNAME,
      STS: "D",
    });
    fetchDatarecipe();

    setSnackbarMessage("Recipe deleted successfully!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
    setOpenGradingDialog(false); // <-- Close the dialog on success
  } catch (error) {
    console.error("Failed to delete item:", error);
    setSnackbarMessage("Failed to delete the item");
    setSnackbarSeverity("error");
    setOpenErrorSnackbar(true);
  }
};

// Add this state
const [datashopOriginal, setDatashopOriginal] = useState([]);

// When you fetch data, set both states
useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await externalgetApi(RECIPE_API_01, "get", {
        COMPCODE: COMPCODE,
        LOCCODE: LOCCODE,
        RESTCODE: RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });

      if (result?.Table2) {
        setDatashop(result.Table2);
        setDatashopOriginal(result.Table2); // <-- Save original
        console.log("Table2 data:", result.Table1);
      } else {
        setDatashop([]);
        setDatashopOriginal([]);
      }
    } catch (err) {
      setDatashop([]);
      setDatashopOriginal([]);
    }
  };

  fetchData();
}, []);

// Update your search effect:
useEffect(() => {
  if (datashopOriginal) {
    const filtered = datashopOriginal.filter((item) => {
      const menuname = item.PRODUCTNAME || "";
      return menuname.toLowerCase().includes(searchText.toLowerCase());
    });
    setDatashop(filtered);
  }
}, [searchText, datashopOriginal]);

const currentMenuCode = selectedMenuCode?.MENUCODE || MENUCODE || "";
const filteredSavedRates = savedRates.filter(
  (item) => String(item.MENUCODE) === String(currentMenuCode)
);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Recipe</Link>
                <Link underline="none">Map Recipe</Link>
              </Breadcrumbs>
            </Grid>

            <Grid item>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
              >
                <Autocomplete
                  options={data2 || []}
                  getOptionLabel={(option) => option.MENUNAME || ""} // 👈 Show MENUNAME in dropdown
                  value={selectedMenuCode} // 👈 Now store the whole object
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setSelectedMenuCode(newValue); // 👈 Save full menu object
                    } else {
                      setSelectedMenuCode(null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Menu Name"
                      fullWidth
                      size="small"
                      sx={{
                        width: "100%",
                        minWidth: 220,
                      }}
                    />
                  )}
                  ListboxProps={{
                    sx: {
                      maxHeight: 150,
                      backgroundColor: "background.paper",
                      "& .MuiAutocomplete-option": {
                        "&:hover": {
                          backgroundColor: "primary.light",
                        },
                        "&.Mui-focused": {
                          backgroundColor: "primary.main",
                          color: "white",
                        },
                      },
                    },
                  }}
                  noOptionsText="No menus available"
                  disabled={!!MENUCODE} // 👈 Disable if MENUCODE already exists
                />

                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
       
        {showUpdateForm && ( <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box
              p={1}
              sx={{
                borderRadius: "4px",
                boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,

                height: {
                  xs: "60.5vh",
                  sm: "60.5vh",
                  md: "65.5vh",
                  lg: "75vh",
                  xl: "75vh",
                },

                "&::-webkit-scrollbar": {
                  width: "0.3em",
                  height: "0.3em",
                },

                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: "2px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: theme.palette.primary.main,
                },

                background: theme.palette.background.paper,
              }}
            >
              <Box
                sx={styles.col_title}
                display={"flex"}
                alignItems={"center"}
                justifyContent="space-between"
              >
                <Typography variant="title" fontWeight={600} align="left">
                  Products
                </Typography>

                <Stack
                  spacing={2}
                  //  padding={1}
                  ml={1}
                >
                  <SearchAppBar
                    onChange={handleSearchChange}
                    value={searchText}
                  />
                  {/* <Button
                                 variant="contained"
                                 startIcon={<AddCircleIcon />}
                                 onClick={() => navigate("/addrecipe")}
                               >
                                 Add Recipe
                               </Button> */}
                </Stack>
              </Box>
              <TableContainer
                component={Paper}
                sx={{
                  overflowY: "auto",
                  overflowX: "auto",
                  height: {
                    xs: "60.5vh",
                    sm: "60.5vh",
                    md: "65.5vh",
                    lg: "60.5vh",
                    xl: "60.5vh",
                  },

                  "&::-webkit-scrollbar": {
                    width: "0.3em",
                    height: "0.3em",
                  },

                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "2px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: theme.palette.primary.main,
                  },
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: "bold",
                          maxWidth: "100px",
                          padding: "1",
                        }}
                      >
                        Products
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ fontWeight: "bold", maxWidth: "150px" }}
                      >
                        Measuring Unit
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", maxWidth: "80px" }}
                      >
                        Quantity
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {datashop.length > 0 ? (
                      datashop.map((row, index) => (
                        <TableRow key={index}>
                          {/* <TableCell align="left">{row.BASECURRENCY}</TableCell> */}
                          <TableCell align="left">{row.PRODUCTNAME}</TableCell>
                          <TableCell align="left">
                         <TableCell align="left">
  {typeof row.MEASURINGUNIT === "object" ? JSON.stringify(row.MEASURINGUNIT) : row.MEASURINGUNIT || ""}
</TableCell>

                          </TableCell>

                          <TableCell sx={{ maxWidth: "100px" }} align="right">

<TextField
  id={`txtrate-${index}`}
  size="small"
  variant="outlined"
  autoComplete="off"
  value={exchangeRates[row.PRODUCTCODE] || ""}
  onChange={(e) => {
    const value = e.target.value;

    // ❌ Non-numeric (excluding dot)
    if (/[^0-9.]/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        [row.PRODUCTCODE]: "Please enter numbers only",
      }));
      return;
    }

    // ❌ More than one dot
    if ((value.match(/\./g) || []).length > 1) {
      setErrors((prev) => ({
        ...prev,
        [row.PRODUCTCODE]: "Please enter numbers only",
      }));
      return;
    }

    // ❌ More than 6 digits before decimal
    const [integerPart = ""] = value.split(".");
    if (integerPart.length > 6) {
      setErrors((prev) => ({
        ...prev,
        [row.PRODUCTCODE]: "Please enter maximum 6 digits before the decimal",
      }));
      return;
    }

    // ❌ More than 5 digits after decimal
    const [, decimalPart] = value.split(".");
    if (decimalPart && decimalPart.length > 5) {
      setErrors((prev) => ({
        ...prev,
        [row.PRODUCTCODE]: "Please enter maximum 5 digits after the decimal",
      }));
      return;
    }

    // ✅ Passed all checks → update value
    handleInputChange(row.PRODUCTCODE, value);
    setErrors((prev) => ({ ...prev, [row.PRODUCTCODE]: "" }));
  }}
  inputProps={{
    inputMode: "decimal",
    pattern: "\\d{0,6}(\\.\\d{0,5})?",
  }}
  error={Boolean(errors[row.PRODUCTCODE])}
  helperText={errors[row.PRODUCTCODE]}
/>




                          </TableCell>
                          <TableCell align="center" padding="none">
                            <Button
                              variant="contained"
                              sx={{
                                background: theme.palette.primary.main,
                                color: theme.palette.text.buttontxt,
                                textTransform: "capitalize",
                                width: "60px",
                              }}
                              onClick={() => handleAddRate(row)}
                            >
                              Add
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} align="center"></TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        
            <Grid item xs={12} sm={12} md={6}>
              <Grid item xs={12}>
                <Box
                  p={1}
                  sx={{
                    borderRadius: "4px",
                    boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,

                    height: {
                      xs: "60.5vh",
                      sm: "60.5vh",
                      md: "65.5vh",
                      lg: "75vh",
                      xl: "75vh",
                    },
                    overflowY: "auto",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      width: "0.3em",
                      height: "0.3em",
                    },

                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: "2px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: theme.palette.primary.main,
                    },

                    background: theme.palette.background.paper,
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="h6" fontWeight={600} align="left">
                      Selected Products For:{" "}
                      {MENUNAME || selectedMenuCode?.MENUNAME || ""}
                    </Typography>

                    <Tooltip title="View Recipe Info" arrow>
                      <IconButton
                        color="primary"
                        onClick={() => setOpenGradingDialog(true)}
                      >
                        <GradingIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <TableContainer
                    component={Paper}
                    sx={{
                      overflowY: "auto",
                      overflowX: "auto",
                      height: {
                        xs: "60.5vh",
                        sm: "60.5vh",
                        md: "65.5vh",
                        lg: "41.5vh",
                        xl: "41.5vh",
                      },

                      "&::-webkit-scrollbar": {
                        width: "0.3em",
                        height: "0.3em",
                      },

                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: "2px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" sx={{ fontWeight: "bold" }}>
                            Product Name
                          </TableCell>
                          <TableCell align="left" sx={{ fontWeight: "bold" }}>
                            Measuring Unit
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold" }}>
                            Quantity
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: "bold" }}>
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>


<TableBody>
  {[...ingredients, ...filteredSavedRates].length > 0 ? (
    [...ingredients, ...filteredSavedRates].map((row, index) => {
      // If this row is from savedRates, show Delete button
      const isSavedRate = index >= ingredients.length;
      const savedRateIndex = index - ingredients.length;
      return (
        <TableRow key={index} title={isSavedRate ? "Not saved yet" : ""}>
          <TableCell align="left">{row.PRODUCTNAME}</TableCell>
          <TableCell align="left">{row.IMMEASURINGUNIT || row.MEASURINGUNIT}</TableCell>
          <TableCell align="right">{row.QTY}</TableCell>
          <TableCell align="center">
            {isSavedRate ? (
              <Button
                variant="contained"
                sx={{
                  background: theme.palette.error.main,
                  color: theme.palette.text.buttontxt,
                  textTransform: "capitalize",
                  width: "60px",
                }}
                onClick={() => handleDeleteRate(savedRateIndex)}
              >
                Delete
              </Button>
            ) : (
              <Button
                variant="contained"
                sx={{
                  background: "#ccc",
                  color: "#fff",
                  textTransform: "capitalize",
                  width: "60px",
                }}
                disabled
              >
                Delete
              </Button>
            )}
          </TableCell>
        </TableRow>
      );
    })
  ) : (
    <TableRow>
      <TableCell colSpan={4} align="center">
        No products added
      </TableCell>
    </TableRow>
  )}
</TableBody>

                    </Table>
                  </TableContainer>
                  <Grid item lg={12} md={6} xs={12} sm={12} mt={3}>
                    <TextField
                      label={<span>Description</span>}
                      id="txtusername"
                      size="small"
                      multiline
                      rows={3}
                      fullWidth
                      variant="outlined"
                      autoComplete="off"
                      name="description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Grid>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                    mt={2}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        ...styles.btn_primary,
                        width: "20%",
                        alignItems: "flex-end",
                        display: "flex",
                      }}
                      onClick={handleUpdate}
                    >
                     Next
                    </Button>
                    {/* <Button
                  variant="contained"
                  sx={{
                    ...styles.btn_primary,
                    width: "20%",
                    alignItems: "flex-end",
                    display: "flex",
                  }}
                 onClick={handleConfirm}
                >
                  Confirm
                </Button> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
       

     
        </Grid> )}
             {openSaveDialog && (
               <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Box
                p={1}
                sx={{
                  borderRadius: "4px",
                  boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                  height: {
                    xs: "60.5vh",
                    sm: "60.5vh",
                    md: "65.5vh",
                    lg: "75vh",
                    xl: "75vh",
                  },
                  overflowY: "auto",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0.3em",
                    height: "0.3em",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "2px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: theme.palette.primary.main,
                  },
                  background: theme.palette.background.paper,
                }}
              >
                {/* Header */}
              <Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"
>
  <Typography variant="h6" fontWeight={600} align="left">
    Recipe Details : {MENUNAME || selectedMenuCode?.MENUNAME || ""}
  </Typography>
  {/* Square image box */}
  <Box
    sx={{
      width: 60,
      height: 60,
      borderRadius: 2,
      overflow: "hidden",
      border: `2px solid ${theme.palette.primary.main}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ml: 2,
      background: "#f9f9f9",
    }}
  >
    <img
      src={selectedMenuCode?.IMAGEPATH }
      alt="Recipe"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </Box>
</Box>
                {/* Message */}
                {saveDialogMessage && (
                  <Box mt={2}>
                    <Typography>{saveDialogMessage}</Typography>
                  </Box>
                )}

                {/* Table */}
                {updatedProducts && updatedProducts.length > 0 ? (
                  <TableContainer
                    component={Paper}
                    sx={{
                      mt: 2,
                      overflowY: "auto",
                      overflowX: "auto",
                      height: {
                        xs: "60.5vh",
                        sm: "60.5vh",
                        md: "65.5vh",
                        lg: "41.5vh",
                        xl: "41.5vh",
                      },
                      "&::-webkit-scrollbar": {
                        width: "0.3em",
                        height: "0.3em",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: "2px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{ fontWeight: "bold", p: 1 }}
                          >
                            Product Name
                          </TableCell>
                          {/* <TableCell
                            align="right"
                            sx={{ fontWeight: "bold", p: 1 }}
                          >
                            With Tax
                          </TableCell> */}
                          <TableCell
  align="right"
  sx={{ fontWeight: "bold", p: 1 }}
>
  <Tooltip title="Without tax" arrow>
    <span>Cost</span>
  </Tooltip>
</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {updatedProducts.map((item, idx) => (
                          <TableRow key={idx}>
                            <TableCell align="left" sx={{ p: 2 }}>
                              {item.productname}
                            </TableCell>
                            {/* <TableCell align="right" sx={{ p: 1 }}>
                              {" "}
                              {Number(item.itemcostwithtax || 0).toFixed(2)}
                            </TableCell> */}
                            <TableCell align="right" sx={{ p: 1 }}>
                              {" "}
                              {Number(item.itemcostwithouttax || 0).toFixed(2)}
                            </TableCell>
                          </TableRow>
                        ))}

                        {/* Total Row */}
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{ fontWeight: "bold", p: 2 }}
                          >
                            Total Cost
                          </TableCell>
                          {/* <TableCell
                            align="right"
                            sx={{ fontWeight: "bold", p: 1 }}
                          >
                            {updatedProducts
                              .reduce(
                                (sum, item) =>
                                  sum + Number(item.itemcostwithtax || 0),
                                0
                              )
                              .toFixed(2)}
                          </TableCell> */}
                          <TableCell
                            align="right"
                            sx={{ fontWeight: "bold", p: 1 }}
                          >
                            {updatedProducts
                              .reduce(
                                (sum, item) =>
                                  sum + Number(item.itemcostwithouttax || 0),
                                0
                              )
                              .toFixed(2)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography mt={2}>No updated products</Typography>
                )}

                {/* Action Buttons */}
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  mt={2}
                  gap={2}
                >
<Button
  variant="contained"
    sx={{
                                    background: theme.palette.primary.main,
                                    color: theme.palette.text.buttontxt,
                                    textTransform: "capitalize",
                                    
                                    width: "80px",
                                  }}
  onClick={() => {
    // Save updatedProducts into sessionStorage
    // if (updatedProducts && updatedProducts.length > 0) {
    //   sessionStorage.setItem("saverates", JSON.stringify(updatedProducts));
    // }

    // Switch to update form
    setShowUpdateForm(true);

    // Close save dialog
    setOpenSaveDialog(false);
  }}
>
  Previous
</Button>

       <Button
                    variant="contained"
                     sx={{
                                    background: theme.palette.primary.main,
                                    color: theme.palette.text.buttontxt,
                                    textTransform: "capitalize",
                                   
                                    width: "80px",
                                  }}
                    onClick={handleConfirm}
                  >
                    Confirm
                  </Button>
                </Box>
              </Box>
            </Grid> </Grid>
          )}
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
      {/* Grading Dialog */}
      <Dialog
        open={openGradingDialog}
        onClose={() => setOpenGradingDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>View Recipe : {MENUNAME}</span>
          <IconButton
            edge="end"
            color="error"
            // onClick={handleDeleteRecipe} // <- define this handler
            aria-label="delete"
            size="small"
          >
           <DeleteIcon onClick={() => handleDelete(MENUCODE, MENUCATCODE)} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>#</strong>
                  </TableCell>
                  {/* <TableCell><strong>Product Code</strong></TableCell> */}
                  <TableCell>
                    <strong>Product Name</strong>
                  </TableCell>
                  {/* <TableCell><strong>Description</strong></TableCell> */}
                  <TableCell align="center" className="text-right">
                    <strong>Quantity</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ingredients.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    {/* <TableCell>{item.PRODUCTCODE}</TableCell> */}
                    <TableCell>{item.PRODUCTNAME}</TableCell>
                    {/* <TableCell>{item.DESCRIPTION}</TableCell> */}
                    <TableCell align="center" className="text-right">
                      {item.QTY}
                    </TableCell>
                  </TableRow>
                ))}
                {ingredients.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No ingredients available.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenGradingDialog(false)}
            variant="contained"
            sx={{ textTransform: "capitalize" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddRecipe;
